import { render, staticRenderFns } from "./optimize-content.vue?vue&type=template&id=586b6720"
import script from "./optimize-content.vue?vue&type=script&lang=js"
export * from "./optimize-content.vue?vue&type=script&lang=js"
import style0 from "./optimize-content.vue?vue&type=style&index=0&id=586b6720&prod&lang=scss"
import style1 from "./optimize-content.vue?vue&type=style&index=1&id=586b6720&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports